export enum Constants {
    ADD_TRIAL_PERIOD_REPORT = 'ADD_TRIAL_PERIOD_REPORT',
    UPDATE_TRIAL_PERIOD_REPORT = 'UPDATE_TRIAL_PERIOD_REPORT',
    REMOVE_TRIAL_PERIOD_REPORT = 'REMOVE_TRIAL_PERIOD_REPORT'
}
